import { get, getDatabase, ref } from 'firebase/database';

/**
 * Service types live at `buildingServices/servicesTypes` and are provisioned
 * per instance (clients cannot write them, see database.rules.json). Their
 * presence is what makes the services analysis meaningful, so the analysis
 * page treats "at least one real service type" as the feature being on.
 */
export const SERVICE_TYPES_PATH = 'buildingServices/servicesTypes';

/** `generalComment` is a free-text log entry, not a service. */
const NON_SERVICE_TYPE_KEYS = new Set(['generalComment']);

/** True when the raw `servicesTypes` node holds at least one real service type. */
export function hasConfiguredServiceTypes(value: unknown): boolean {
    if (!value || typeof value !== 'object') return false;
    return Object.keys(value).some(key => !NON_SERVICE_TYPE_KEYS.has(key));
}

/**
 * Read once per app session and keep the result, like `customerTypeApi`:
 * the node only changes when an instance is provisioned.
 */
let cached: Promise<boolean> | null = null;

export function getHasServiceTypes(): Promise<boolean> {
    if (!cached) {
        cached = get(ref(getDatabase(), SERVICE_TYPES_PATH))
            .then(snapshot => hasConfiguredServiceTypes(snapshot.val()))
            .catch(err => {
                console.error('Failed to read service types', err);
                cached = null;
                return false;
            });
    }
    return cached;
}
